import { Select as AntdSelect } from "antd";

const { Option } = AntdSelect;
export const Select = ({ options = [], defaultValue, onChange }) => {
  return (<AntdSelect defaultValue={defaultValue} onChange={onChange}>
    {options.map(option => 
      <Option key={option.value} value={option.value}>{option.text}</Option>  
    )}
  </AntdSelect>)
}